import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Divisions from '../components/Divisions';
import Electronics from '../components/Electronics';
import WhoWeAre from '../components/WhoWeAre';
import Services from '../components/Services';
import Products from '../components/Products';
import WhyChoose from '../components/WhyChoose';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { useContent } from '../hooks/useContent';

const Home = () => {
  const { content } = useContent();

  return (
    <div className="bg-[#f5f5f8] text-left">
      <Header navItems={content.nav} />
      <main>
        <Hero hero={content.hero} />
        <Divisions items={content.divisions} />
        <Electronics data={content.electronics} />
        <WhoWeAre data={content.whoweare} />
        <Services items={content.services} />
        <Products items={content.offerings} />
        <WhyChoose why={content.whyChoose} industries={content.industries} />
        <Contact info={content.contact} />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
